import { render, staticRenderFns } from "./slot-picker.mpx?vue&type=template&id=4060b0f9&isComponent&outputPath=components%2Fslot-picker152c2006%2Findex"
import script from "./slot-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fslot-picker152c2006%2Findex"
export * from "./slot-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fslot-picker152c2006%2Findex"
import style0 from "./slot-picker.mpx?vue&type=style&index=0&id=4060b0f9&prod&lang=stylus&mpxStyleOptions=%7B%22scoped%22%3Atrue%2C%22mid%22%3A%22_152c2006%22%7D&isComponent&outputPath=components%2Fslot-picker152c2006%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports